import { render, staticRenderFns } from "./SessionsView.vue?vue&type=template&id=8f24cf66&"
import script from "./SessionsView.vue?vue&type=script&lang=js&"
export * from "./SessionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports